<template>
  <div class="TestInfoList">
    <AppHeader :content="content"></AppHeader>
    <AppBox>
      <div class="filter">
        <date-select ref="dateSelect" @pick="handleTimePick"></date-select>
      </div>
      <div class="content">
        <el-timeline>
          <el-timeline-item v-for="(item, index) in data" :timestamp="item.date" placement="top">
            <el-card>
              <div v-if="item.testRecords?.length" v-for="record in item.testRecords">
                <div v-if="record.finish">
                  <!--                当天完成-->
                  <div v-if="record.finishOneDay">
                    <span>当天完成了”{{ record.title }}”的测验。</span>
                    <span>答对{{ record.correctCount }}道，</span>
                    <span>答错{{ record.errorCount }}道，</span>
                    <span>超过当时{{ record.beforeRate }}%的参与者。</span>
                  </div>
                  <!--                非当天完成-->
                  <div v-else>
                    <div v-if="record.finishOneDay">
                      <span>完成了”{{ record.title }}”的测验。</span>
                      <span>答对{{ record.correctCount }}道，</span>
                      <span>答错{{ record.errorCount }}道，</span>
                      <span>超过当时{{ record.beforeRate }}%的参与者。</span>
                    </div>
                  </div>
                </div>
                <!--              开始学习，没有完成-->
                <div v-else>开始进行”{{ record.title }}”的测验</div>
              </div>
              <div v-if="item.totalAnswer">今日共练习{{ item.totalAnswer }}道题</div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </AppBox>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import DateUtil from "@/utils/formatDate";
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBody from "@/components/layout/AppBody.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import DateSelect from "@/components/dateSelect/index.vue";

export default {
  name: "TestInfoList",
  components: {DateSelect, AppBox, AppBody, AppHeader},
  data() {
    return {
      content: "测验记录",
      filter: {
        id: 0,
        startTime: null,
        endTime: null,
      },
      data: []
    };
  },
  created() {
    this.filter.id = Number.parseInt(this.$Base64.decode(this.$route.params.userId));
  },
  mounted() {
    this.filter.startTime = this.$refs.dateSelect.dateRange[0]
    this.filter.endTime = this.$refs.dateSelect.dateRange[1]
    this.loadData();
  },
  computed: {},
  methods: {
    ...mapActions("pluginCenter", ["getUserTestReport"]),
    handleTimePick(date) {
      if (date && date.length === 2) {
        this.filter.startTime = date[0];
        this.filter.endTime = date[1];
      } else {
        this.filter.startTime = this.filter.endTime = null;
      }
      this.loadData();
    },
    async loadData() {
      let response = await this.getUserTestReport(this.filter);
      this.data = response.data;
    },
    //   根据时间戳计算年龄
    formatAge(timestamp) {
      return DateUtil.calculateAgeFromTimestamp(timestamp);
    },
    //   根据时间戳计算日期
    formatDate(timestamp) {
      return DateUtil.formatDateFromTimestamp(timestamp);
    },
    //   根据时间戳计算日期
    formatDateYYYYMMDDHHmm(timestamp) {
      return DateUtil.formatDateCommitTimestamp(timestamp);
    },
  },
};
</script>

<style lang="scss" scoped>
.TestInfoList {
  .appBox {
    min-height: calc(100vh - 155px);
  }

  .filter {
    padding-bottom: 20px;
  }

  .content {
    height: calc(100vh - 30vh);
    overflow-y: auto;
  }
}
</style>
